import { FormControl, FormErrorMessage, Input } from '@chakra-ui/react';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import FormLabelCustom from './FormLabel';

// Input de moeda no padrão do admin: digita os centavos da direita para a
// esquerda (ex.: "12345" -> "R$ 123,45"). O valor do formulário é um número em reais.
const currencyFormatter = (value: string) => {
  const digits = String(value ?? '0').replace(/\D/g, '');
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(digits) / 100);
};

const currencyToNumber = (value: string) => Number(value.replace(/\D/g, '')) / 100;

const CurrencyInput: React.FC<{
  control: Control<any>;
  label: string;
  name: string;
  placeholder?: string;
  rules?: RegisterOptions<any>;
}> = ({ control, label, rules, name, placeholder }) => {
  const [inputValue, setInputValue] = React.useState('0');

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, name: fieldName, value }, fieldState: { invalid, error, isDirty } }) => (
        <FormControl isInvalid={invalid}>
          <FormLabelCustom name={label} label={label} props={{}} />
          <Input
            name={fieldName}
            value={currencyFormatter(isDirty ? inputValue : (+value || 0).toFixed(2))}
            size="sm"
            bg="white"
            type="text"
            inputMode="numeric"
            placeholder={placeholder}
            onFocus={(e) => e.target.setSelectionRange(e.target.value.length, e.target.value.length)}
            onPasteCapture={(e) => {
              e.preventDefault();
              let pasted = e.clipboardData.getData('Text');
              if (!pasted.includes('.') && !pasted.includes(',')) pasted = `${pasted}00`;
              const n = currencyToNumber(currencyFormatter(pasted));
              setInputValue(n.toFixed(2));
              onChange(n);
            }}
            onChange={(e) => {
              const n = currencyToNumber(currencyFormatter(e.target.value));
              setInputValue(n.toFixed(2));
              onChange(n);
            }}
          />
          <FormErrorMessage>{error?.message || 'Campo inválido'}</FormErrorMessage>
        </FormControl>
      )}
    />
  );
};

export default CurrencyInput;
